<template>
    <div>
        <div v-if="this.index == 0">
            <canvas id="canvas_preview_1" width="580" height="406" class="c-preview__canvas" style="display: none"></canvas>
            <canvas id="face_canvas_preview_1" width="580" height="406" class="" style="display: none"></canvas>
        </div>
        <div v-else-if="this.index == 1">
            <canvas id="canvas_preview_2" width="580" height="406" class="c-preview__canvas" style="display: none"></canvas>
            <canvas id="face_canvas_preview_2" width="580" height="406" class="" style="display: none"></canvas>
        </div>
        <div v-else-if="this.index == 2">
            <canvas id="canvas_preview_3" width="580" height="406" class="c-preview__canvas" style="display: none"></canvas>
            <canvas id="face_canvas_preview_3" width="580" height="406" class="" style="display: none"></canvas>
        </div>
        <div class="c-preview__avatar" :if="this.previewImage"><img :src="previewImage" alt="" /></div>
        <div class="c-preview__name">{{ name }}</div>
    </div>
</template>

<script>
export default {
    name: "AvatarPreview",
    props: {
        avatarData: {
            type: Object,
            default: null,
            required: true,
        },
        index: {
            type: Number,
            default: 0,
            required: true,
        },
    },
    data() {
        return {
            body: [
                {
                    src: "parts/body/body-1.png",
                },
                {
                    src: "parts/body/body-2.png",
                },
            ],
            face: [
                {
                    src: "parts/face/face-1.png",
                },
                {
                    src: "parts/face/face-2.png",
                },
                {
                    src: "parts/face/face-3.png",
                },
                {
                    src: "parts/face/face-4.png",
                },
                {
                    src: "parts/face/face-5.png",
                },
            ],
            hair: [
                {
                    src: "parts/hair/hair-1.png",
                },
                {
                    src: "parts/hair/hair-2.png",
                },
                {
                    src: "parts/hair/hair-3.png",
                },
                {
                    src: "parts/hair/hair-4.png",
                },
                {
                    src: "parts/hair/hair-5.png",
                },
                {
                    src: "parts/hair/hair-6.png",
                },
                {
                    src: "parts/hair/hair-7.png",
                },
                {
                    src: "parts/hair/hair-8.png",
                },
                {
                    src: "parts/hair/hair-9.png",
                },
                {
                    src: "parts/hair/hair-10.png",
                },
                {
                    src: "parts/hair/hair-11.png",
                },
                {
                    src: "parts/hair/hair-12.png",
                },
                {
                    src: "parts/hair/hair-13.png",
                },
                {
                    src: "parts/hair/hair-14.png",
                },
                {
                    src: "parts/hair/hair-15.png",
                },
                {
                    src: "parts/hair/hair-16.png",
                },
                {
                    src: "parts/hair/hair-17.png",
                },
                {
                    src: "parts/hair/hair-18.png",
                },
                {
                    src: "parts/hair/hair-19.png",
                },
                {
                    src: "parts/hair/hair-20.png",
                },
                {
                    src: "parts/hair/hair-21.png",
                },
                {
                    src: "parts/hair/hair-22.png",
                },
                {
                    src: "parts/hair/hair-23.png",
                },
                {
                    src: "parts/hair/hair-24.png",
                },
                {
                    src: "parts/hair/hair-25.png",
                },
                {
                    src: "parts/hair/hair-26.png",
                },
                {
                    src: "parts/hair/hair-27.png",
                },
                {
                    src: "parts/hair/hair-28.png",
                },
                {
                    src: "parts/hair/hair-29.png",
                },
                {
                    src: "parts/hair/hair-30.png",
                },
                {
                    src: "parts/hair/hair-31.png",
                },
                {
                    src: "parts/hair/hair-32.png",
                },
                {
                    src: "parts/hair/hair-33.png",
                },
                {
                    src: "parts/hair/hair-34.png",
                },
                {
                    src: "parts/hair/hair-35.png",
                },
                {
                    src: "parts/hair/hair-36.png",
                },
                {
                    src: "parts/hair/hair-37.png",
                },
                {
                    src: "parts/hair/hair-38.png",
                },
                {
                    src: "parts/hair/hair-39.png",
                },
                {
                    src: "parts/hair/hair-40.png",
                },
                {
                    src: "parts/hair/hair-41.png",
                },
                {
                    src: "parts/hair/hair-42.png",
                },
                {
                    src: "parts/hair/hair-43.png",
                },
                {
                    src: "parts/hair/hair-44.png",
                },
                {
                    src: "parts/hair/hair-45.png",
                },
                {
                    src: "parts/hair/hair-46.png",
                },
                {
                    src: "parts/hair/hair-47.png",
                },
            ],
            backhair: [
                {
                    src: "parts/backhair/backhair-1.png",
                },
                {
                    src: "parts/backhair/backhair-2.png",
                },
                {
                    src: "parts/backhair/backhair-3.png",
                },
                {
                    src: "parts/backhair/backhair-4.png",
                },
                {
                    src: "parts/backhair/backhair-5.png",
                },
                {
                    src: "parts/backhair/backhair-6.png",
                },
                {
                    src: "parts/backhair/backhair-7.png",
                },
                {
                    src: "parts/backhair/backhair-8.png",
                },
                {
                    src: "parts/backhair/backhair-9.png",
                },
                {
                    src: "parts/backhair/backhair-10.png",
                },
                {
                    src: "parts/backhair/backhair-11.png",
                },
                {
                    src: "parts/backhair/backhair-12.png",
                },
                {
                    src: "parts/backhair/backhair-13.png",
                },
                {
                    src: "parts/backhair/backhair-14.png",
                },
                {
                    src: "parts/backhair/backhair-15.png",
                },
                {
                    src: "parts/backhair/backhair-16.png",
                },
                {
                    src: "parts/backhair/backhair-17.png",
                },
                {
                    src: "parts/backhair/backhair-18.png",
                },
                {
                    src: "parts/backhair/backhair-19.png",
                },
                {
                    src: "parts/backhair/backhair-20.png",
                },
                {
                    src: "parts/backhair/backhair-21.png",
                },
                {
                    src: "parts/backhair/backhair-22.png",
                },
                {
                    src: "parts/backhair/backhair-23.png",
                },
                {
                    src: "parts/backhair/backhair-24.png",
                },
                {
                    src: "parts/backhair/backhair-25.png",
                },
                {
                    src: "parts/backhair/backhair-26.png",
                },
                {
                    src: "parts/backhair/backhair-27.png",
                },
                {
                    src: "parts/backhair/backhair-28.png",
                },
                {
                    src: "parts/backhair/backhair-29.png",
                },
                {
                    src: "parts/backhair/backhair-30.png",
                },
                {
                    src: "parts/backhair/backhair-31.png",
                },
                {
                    src: "parts/backhair/backhair-32.png",
                },
                {
                    src: "parts/backhair/backhair-33.png",
                },
                {
                    src: "parts/backhair/backhair-34.png",
                },
                {
                    src: "parts/backhair/backhair-35.png",
                },
                {
                    src: "parts/backhair/backhair-36.png",
                },
                {
                    src: "parts/backhair/backhair-37.png",
                },
                {
                    src: "parts/backhair/backhair-38.png",
                },
                {
                    src: "parts/backhair/backhair-39.png",
                },
                {
                    src: "parts/backhair/backhair-40.png",
                },
                {
                    src: "parts/backhair/backhair-41.png",
                },
                {
                    src: "parts/backhair/backhair-42.png",
                },
                {
                    src: "parts/backhair/backhair-43.png",
                },
                {
                    src: "parts/backhair/backhair-44.png",
                },
                {
                    src: "parts/backhair/backhair-45.png",
                },
                {
                    src: "parts/backhair/backhair-46.png",
                },
                {
                    src: "parts/backhair/backhair-47.png",
                },
            ],
            eye: [
                {
                    src: "parts/eye/eye-1.png",
                },
                {
                    src: "parts/eye/eye-2.png",
                },
                {
                    src: "parts/eye/eye-3.png",
                },
                {
                    src: "parts/eye/eye-4.png",
                },
                {
                    src: "parts/eye/eye-5.png",
                },
                {
                    src: "parts/eye/eye-6.png",
                },
                {
                    src: "parts/eye/eye-7.png",
                },
                {
                    src: "parts/eye/eye-8.png",
                },
                {
                    src: "parts/eye/eye-9.png",
                },
            ],
            nose: [
                {
                    src: "parts/nose/nose-1.png",
                },
                {
                    src: "parts/nose/nose-2.png",
                },
                {
                    src: "parts/nose/nose-3.png",
                },
                {
                    src: "parts/nose/nose-4.png",
                },
                {
                    src: "parts/nose/nose-5.png",
                },
                {
                    src: "parts/nose/nose-6.png",
                },
            ],
            accessory: [
                {
                    src: "parts/accessory/accessory-0.png",
                },
                {
                    src: "parts/accessory/accessory-1.png",
                },
                {
                    src: "parts/accessory/accessory-2.png",
                },
                {
                    src: "parts/accessory/accessory-3.png",
                },
                {
                    src: "parts/accessory/accessory-4.png",
                },
                {
                    src: "parts/accessory/accessory-5.png",
                },
                {
                    src: "parts/accessory/accessory-6.png",
                },
                {
                    src: "parts/accessory/accessory-7.png",
                },
                {
                    src: "parts/accessory/accessory-8.png",
                },
                {
                    src: "parts/accessory/accessory-9.png",
                },
            ],
            cheek: [
                {
                    src: "parts/other/cheek-1.png",
                },
            ],
            mouth: [
                {
                    src: "parts/mouth/mouth-1.png",
                },
                {
                    src: "parts/mouth/mouth-2.png",
                },
                {
                    src: "parts/mouth/mouth-3.png",
                },
                {
                    src: "parts/mouth/mouth-4.png",
                },
            ],
            eyebrows: [
                {
                    src: "parts/eyebrows/eyebrows-1.png",
                },
                {
                    src: "parts/eyebrows/eyebrows-2.png",
                },
                {
                    src: "parts/eyebrows/eyebrows-3.png",
                },
                {
                    src: "parts/eyebrows/eyebrows-4.png",
                },
                {
                    src: "parts/eyebrows/eyebrows-5.png",
                },
                {
                    src: "parts/eyebrows/eyebrows-6.png",
                },
            ],
            parts_menu: [
                {
                    name: "face",
                    alt: "輪郭",
                },
                {
                    name: "hair",
                    alt: "髪型",
                },
                {
                    name: "eyebrows",
                    alt: "眉毛",
                },
                {
                    name: "eye",
                    alt: "目",
                },
                {
                    name: "nose",
                    alt: "鼻",
                },
                {
                    name: "mouth",
                    alt: "口",
                },
                {
                    name: "accessory",
                    alt: "アクセサリー",
                },
            ],
            selectedPart: {
                backhair: "",
                hair: "",
                // body: '',
                face: "",
                eye: "",
                nose: "",
                accessory: "",
                cheek: "",
                mouth: "",
                eyebrows: "",
            },
            previewImage: null,
            name: "",
            propsAvatarData: null,
        };
    },
    async mounted() {
        this.propsAvatarData = await this.avatarData;
        this.setData();
        this.setCanvas();
    },
    methods: {
        setData: function () {
            // 初期値を代入
            this.selectedPart.backhair = this.backhair[this.propsAvatarData.hair["id"] - 1].src;
            this.selectedPart.hair = this.hair[this.propsAvatarData.hair["id"] - 1].src;
            this.selectedPart.body = this.body[this.propsAvatarData.body["id"] - 1].src;
            this.selectedPart.face = this.face[this.propsAvatarData.face["id"] - 1].src;
            this.selectedPart.eye = this.eye[this.propsAvatarData.eye["id"] - 1].src;
            this.selectedPart.nose = this.nose[this.propsAvatarData.nose["id"] - 1].src;
            this.selectedPart.cheek = this.cheek[0].src;
            this.selectedPart.mouth = this.mouth[this.propsAvatarData.mouth["id"] - 1].src;
            this.selectedPart.eyebrows = this.eyebrows[this.propsAvatarData.eyebrows["id"] - 1].src;
            if (this.propsAvatarData.accessory["id"] == 0) {
                this.selectedPart.accessory = this.accessory[0].src;
            } else {
                this.selectedPart.accessory = this.accessory[this.propsAvatarData.accessory["id"]].src;
            }
            this.name = this.propsAvatarData.name;
        },
        setCanvas: async function () {
            // Canvasに選択した画像を書き込む
            // console.log("キャンバスのindex", this.index);
            let $canvas;
            if (this.index == 0) {
                $canvas = document.getElementById("canvas_preview_1");
            } else if (this.index == 1) {
                $canvas = document.getElementById("canvas_preview_2");
            } else if (this.index == 2) {
                $canvas = document.getElementById("canvas_preview_3");
            }

            const context = $canvas.getContext("2d");
            // パーツの生成をする順番（上から順）
            const imageOrder = [
                "backhair",
                // 'body',
                "face",
                "hair",
                "eye",
                "nose",
                "cheek",
                "mouth",
                "eyebrows",
                "accessory",
            ];
            context.clearRect(0, 0, $canvas.width, $canvas.height);
            for (let part of imageOrder) {
                const image = await this.setImage(context, part);
                context.drawImage(image, 0, 0, $canvas.width, $canvas.height);
            }

            // const $face_canvas = document.getElementById("face_canvas_preview");
            let $face_canvas;
            if (this.index == 0) {
                $face_canvas = document.getElementById("face_canvas_preview_1");
            } else if (this.index == 1) {
                $face_canvas = document.getElementById("face_canvas_preview_2");
            } else if (this.index == 2) {
                $face_canvas = document.getElementById("face_canvas_preview_3");
            }

            const face_context = $face_canvas.getContext("2d");
            // パーツの生成をする順番（上から順）
            const face_imageOrder = ["backhair", "body" ,"face", "hair", "eye", "nose", "cheek", "mouth", "eyebrows", "accessory"];

            let dy = 0;
            face_context.clearRect(0, 0, $face_canvas.width, $face_canvas.height);
            for (let partF of face_imageOrder) {
                const face_image = await this.setImage(face_context, partF);
                //小さい顔を選択時、下に下げる
                if (partF != "body" && this.selectedPart.face.split("-")[1].split(".")[0] == 2) {
                    dy = 25;
                } else {
                    dy = 0;
                }
                face_context.drawImage(face_image, 0, dy, $face_canvas.width, $face_canvas.height);
            }
            // this.setLoadAllCallback([image_p5, layer_p5, mixA_p5, mixB_p5], function () {

            // });
            const base64Image = await face_context.canvas.toDataURL("image/png");
            this.previewImage = await base64Image;
        },
        setLoadAllCallback: function (elems, callback) {
            var count = 0;
            for (var i = 0; i < elems.length; ++i) {
                elems[i].onload = function () {
                    ++count;
                    if (count == elems.length) {
                        // All elements have been loaded.
                        callback(elems);
                    }
                };
            }
        },
        setImage: function (context, part) {
            // 画像を順番通りに読み込ませる
            const imageName = this.selectedPart[part];
            // console.log("■index >> ", this.index);
            return new Promise(function (resolve, reject) {
                const image = new Image();
                // console.log("imageName", imageName);
                //image.src = `img/${imageName}`;
                image.src = require(`@/assets/img/${imageName}`);
                image.onload = function () {
                    resolve(image);
                    // console.log("img loaded >>" , image.src)
                };
                image.onerror = function (e) {
                    console.log(e);
                    reject("画像の読み込みに失敗しました");
                };
            });
        },
    },
};
</script>
